// 当前运营控制台源码维护说明，更新时间：2026-09-01 01:01 CST。后续修改本文件功能时，请同步更新注释、版本号和更新时间。
let dirty = false;

export function setConsoleNavigationDirty(value: boolean) {
  dirty = value;
}

export function isConsoleNavigationDirty() {
  return dirty;
}

export function clearConsoleNavigationDirty() {
  dirty = false;
}
